<template>
	<section>
		<h3>Attachments</h3>

		<template v-if="hasFiles">

			<p>Selecting images and files here will attach links to them in the {{typeName.toLowerCase()}} email notice</p>

			<h4>Files</h4>

			<div>
				<label class="mr-3" style="font-weight: bold;">Filter:</label>
				<label v-for="tag in tags" class="mr-3">
					<input type="checkbox" v-model="selectedTags" :value="tag.id">
					{{tag.name}}
				</label>
			</div>

			<file-list-item v-for="file in mutatedFiles"
				:thumb-src="file.thumbSrc"
				:src="file.src"
				:id="file.UploadFile.id"
				:filename="file.UploadFile.original_filename"
				:non-editable="true"
				:selectable="!isFinalized"
				:tags="file.tags"
				v-on:selectChange="fileSelectChange($event,file)"
				:value="selectedFiles.indexOf(file.id) >= 0">
			</file-list-item>

			<!--<h4 class="mt-4">Files</h4>

			<div v-for="(file,index) in $store.service.ServiceFile">
				<label>
					<input type="checkbox" v-model="selectedFiles" :value="file.id" v-on:change="saveAttachedFiles">
					{{ file.UploadFile.original_filename }}
				</label>
			</div>-->

			<h4 class="mt-4">Service Work Order Summaries</h4>

			<div v-for="snapshot in serviceSnapshots">
				<label>
					<input type="checkbox" v-model="attachedWoSummaries" :disabled="isFinalized ? true : false" :value="snapshot.id" v-on:change="attachedWoSummariesChange">
					{{formatDateTimeToLocal(snapshot.created_at)}}
				</label>
			</div>

			<p v-if="$store.service.ServiceFile.length == 0">No files</p>

		</template>
		<p v-else>
			There are no files that belong to this service. To upload some files, flip over to the <router-link :to="'/service/'+$route.params.id+'/files'">Files</router-link> tab
		</p>

	</section>
</template>
<script type="text/javascript">
import ImagePanel from "@/components/ImagePanel"
import FileListItem from "@/components/FileListItem"

import ServiceMixins from "@/mixins/ServiceMixins.js"

export default {
	name: "InvoiceAttachmentsSection",
	components: {
		FileListItem
	},
	mixins: [ServiceMixins],
	props: [
		"selectedFilesProp",
		"invoiceId",
		"serviceId",
		"typeName",
		"attachedWoSummariesJson",
		"isFinalized"
	],
	data() {
		return {
			selectedFiles: this.selectedFilesProp,
			attachedWoSummaries: [],
			serviceSnapshots: [],
			tags: [],
			selectedTags: []
		}
	},
	watch: {
		selectedFilesProp() {
			this.selectedFiles = this.selectedFilesProp
		},
		attachedWoSummariesJson() {
			this.setAttachedWoSummaries()
		},
		serviceId() {
			this.fetchSnapshots()
		}
	},
	computed: {
		mutatedFiles() {
			let vm = this

			return this.$store.service.ServiceFile.map(file => {

				if ("FileTag" in file) {
					file.tags = file.FileTag.map(tag => {
						return tag.name
					})
				}
				else file.tags = []

				file.src = vm.apiRoot + 'resources/files/'+vm.$store.sessionToken+'/'+file.UploadFile.filename

				file.thumbSrc = file.src
				if (file.UploadFile.thumb_filename != "")
					file.thumbSrc = vm.apiRoot + 'resources/images/'+vm.$store.sessionToken+'/'+file.UploadFile.thumb_filename

				return file
			}).filter(file => {
				if (!("FileTag" in file) || this.selectedTags.length == 0)
					return true
				else {
					let hasTag = false
					return file.FileTag.find(tag => {
						return vm.selectedTags.indexOf(tag.id) >= 0
					})
				}
			})
		},
		hasFiles() {
			if (this.$store.service.ServiceFile.length > 0)
				return true
			else
				return false
		},
	},
	methods: {
		setAttachedWoSummaries() {
			this.attachedWoSummaries = []
			try {
				this.attachedWoSummaries = JSON.parse(this.attachedWoSummariesJson)
			}
			catch (e) {}

		},
		fileSelectChange(state,file) {
			if (state)
				this.selectedFiles.push(file.id)
			else {
				let index = this.selectedFiles.indexOf(file.id)
				this.selectedFiles.splice(index,1)
			}

			this.$emit("selectionChange",this.selectedFiles)

			this.saveAttachedFiles()
		},
		attachedWoSummariesChange() {
			let vm = this

			let attached_wo_summaries_json = JSON.stringify(this.attachedWoSummaries)

			let payload = {
				id: this.invoiceId,
				attached_wo_summaries_json,
				skipQBOPush: true
			}

			this.postData("ServiceInvoice/save",payload).then(response => {
				if (response.success)
					vm.$emit("attachedWoSummariesChange",vm.attached_wo_summaries_json)
			})
		},
		saveAttachedFiles() {

			let payload = {
				id: this.invoiceId,
				attached_files_json: JSON.stringify(this.selectedFiles),
				skipQBOPush: true
			}

			this.postData("ServiceInvoice/save",payload,false)
		},
		fetchServiceFiles() {
			let vm = this

			let params = {
				filters: [
					["service_id",this.serviceId]
				],
				include: ["FileTag","UploadFile"]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("ServiceFile/get",params).then(response => {
					if (response.success)
						vm.$store.service.ServiceFile = response.data

					resolve(response)
				})
			})
		},
		fetchServiceTags() {
			let vm = this

			let params = {
				filters: [
					["is_for_services",1]
				]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("FileTag/get",params).then(response => {
					if (response.success)
						vm.tags = response.data
				
					resolve(response)
				})
			})
		},
		fetchSnapshots() {
			let vm = this

			let params = {
				filters: [
					["service_id",this.serviceId]
				],
				fields: ["id","slug","created_at"]
			}

			return new Promise((resolve,reject) => {
				vm.getJSON("ServiceSnapshot/get",params).then(response => {
					if (response.success)
						vm.serviceSnapshots = response.data
				
					resolve(response)
				})
			})
		},
		fetchData() {
			let vm = this

			let promises = [
				this.fetchServiceTags()
			]

			if (this.serviceId) {
				promises.push(this.fetchServiceFiles())
				promises.push(this.fetchSnapshots())
			}

			this.spinner(true)

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
		}
	},
	created() {
		this.fetchData()

		this.setAttachedWoSummaries()
	}
}
</script>

<style type="text/css" scoped>
	.attachment-image-thumb {
		width: 80px;
		height: 80px;
		display: inline-block;
	}
</style>